import React, { useEffect, useState } from 'react';
import { Grid, Button } from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import { leaveTeam } from 'redux/thunks';
import { ModalWrapper } from 'components/Modals';
import BrokenTokenIcon from 'assets/images/broken-token.svg';
import { LoaderButton } from 'components/LoaderButton';
import { RootStore } from 'redux/store';
import './LeaveTeamModal.scss';
import { TeamUsers } from 'redux/models/teamUsers';

interface CreditsModalProps {
	open: boolean;
	teamId: string;
	teamName: string;
	onCloseClicked: () => void;
	allowClickOutsideToClose?: boolean;
}

const LeaveTeamModal: React.FC<CreditsModalProps> = (props: CreditsModalProps) => {
	const dispatch = useDispatch();
	const [leaveable, setLeaveable] = useState(true);
	const leavingTeam = useSelector((state: RootStore) => state.user.leavingTeam);
	const teamUsers = useSelector((state: RootStore) => state.user.users);
	const userId = useSelector((state: RootStore) => state.user.userId);
	const selectedTeam = useSelector((state: RootStore) => state.user.selectedTeam);
	const { open, teamName, teamId, allowClickOutsideToClose, onCloseClicked } = props;

	useEffect(() => {
		if (!open) return;
		setLeaveable(true);

		if (selectedTeam?.isAdmin) {
			const foundAdmin = teamUsers.some((user: TeamUsers) => {
				if (user.isAdmin && user.userId !== userId) {
					return true;
				}
				return false;
			});
			setLeaveable(foundAdmin);
		}
	}, [open, teamUsers, setLeaveable, selectedTeam, userId]);

	const dispatchLeaveTeam = () => {
		onCloseClicked();
		dispatch(leaveTeam(teamId));
	};

	const loaderButtonProps = {
		loading: leavingTeam,
		onHandleClick: dispatchLeaveTeam,
	};

	return (
		<ModalWrapper open={open} onCloseClicked={onCloseClicked} allowClickOutsideToClose={allowClickOutsideToClose}>
			<Grid container direction='column' alignItems='center' className='confirmation-container'>
				<img src={BrokenTokenIcon} className='token-icon' alt='toa-token' />
				<div className='toa-title'>Leave team?</div>
				{leaveable ? (
					<>
						<div className='confirmation-text'>
							Are you sure you want to leave <span className='team-name'>{teamName}</span>? You cannot undo this action.
						</div>
						<div className='confirmation-button-container'>
							<Button variant='contained' color='primary' className='confirmation-cancel-button' onClick={onCloseClicked}>
								cancel
							</Button>
							<LoaderButton id='leave-team-button' type={'button'} {...loaderButtonProps}>
								Leave Team
							</LoaderButton>
						</div>
					</>
				) : (
					<div className='confirmation-text'>
						Sorry, but you're unable to leave this team (<span className='team-name'>{teamName}</span>) because you are the only admin. Please
						assign someone else to be an admin or delete this team completely if it is no longer needed.
					</div>
				)}
			</Grid>
		</ModalWrapper>
	);
};

export default LeaveTeamModal;
